import {useContext} from "react";
import ClienteDirectoContext from "../../../context/ClienteDirectoContext";
import {ReactComponent as EmailIcon} from '../../../assets/icons/ic_email.svg';
import {ReactComponent as LocationIcon} from '../../../assets/icons/ic_location.svg';
import {ReactComponent as WhatsappIcon} from '../../../assets/icons/ic_whatsapp.svg';
import {FacebookIcon, InstagramIcon, LinkedinIcon, OtherIcon} from "../../../assets/socialMedia";
import "./Producer.css";

const Producer = () => {
    const {datosPolkista, datosMaster, description, redesSociales} = useContext(ClienteDirectoContext);

    const siteIcons = {
        facebook: FacebookIcon,
        instagram: InstagramIcon,
        linkedin: LinkedinIcon,
        other: OtherIcon,
    }
    const getIcon = (url) => {
        const site = Object.keys(siteIcons).find((key) => key !== "other" && url.includes(key));
        return siteIcons[site] || siteIcons.other;
    };


    return (
        <section className='producer'>
            <div className='name'>
                <h2>{datosPolkista.Nombre + " " + datosPolkista.Apellido}</h2>
                {/* TODO: handle null matricula values if necessary */}
                <h3>{"SSN Matrícula " + datosMaster.matricula}</h3>
            </div>
            <div className='description'>
                <ul>
                    {
                        description.map((item, index) => {
                            return <li key={index}>{item}</li>
                        })
                    }
                </ul>
            </div>
            <div className='contactoContainer'>
                <div className='contacto'>
                            <span>
                                <WhatsappIcon/>
                                <p>{datosMaster.telefono}</p>
                            </span>
                    <span>
                                <EmailIcon/>
                                <p>{datosMaster.email}</p>
                            </span>
                    <span className="ubicacion">
                                <LocationIcon/>
                                <p>{datosMaster.direccion}</p>
                            </span>
                </div>
                {redesSociales.length > 0 && (
                    <div className="socialmedia">
                        {redesSociales.map((url, index) => {
                            const Icon = getIcon(url);
                            const href = url.startsWith("http") ? url : `https://${url}`;

                            return (
                                <a key={index} href={href} target="_blank">
                                    <Icon/>
                                </a>
                            );
                        })}
                    </div>
                )}
            </div>
        </section>
    )
};

export default Producer;